import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VRow,[_c(VCol,{attrs:{"cols":"12"}},[_c('h1',[_vm._v(" About elements ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }